<template>
    <div class="wizard-footer">
        <span class="u-margin-bottom-responsive">
            <small
                v-html="
                    trans('order.support', {
                        email: this.supportEmail,
                        phone: this.supportPhone,
                        phoneHref: this.supportPhoneHref
                    })
                "
            ></small>
        </span>

        <small class="product__title-meta | u-margin-bottom-responsive">{{ trans('order.tax') }}</small>

        <slot></slot>
    </div>
</template>

<script>
import { supportMixin } from 'relapp-register';

export default {
    mixins: [supportMixin]
};
</script>
